import { useGestock } from "../GestockContext";
import { useDashboard } from "../useOilmed";
import { fmt } from "../utils";

const PROD_LABEL = { essence: "Super", go: "Go" };

export default function GDashboard() {
  const { terminal, produit, setActivePage } = useGestock();
  const { stockProduit, totalBLRestant, totalStations, alertes, loading } =
    useDashboard(terminal, produit);

  const prodLabel = PROD_LABEL[produit];
  const accentColor = produit === "essence" ? "var(--blue)" : "var(--orange)";

  return (
    <div className="fade-up">
      <div className="page-header">
        <div className="page-title">
          Tableau de <span style={{ color: accentColor }}>Bord</span>
        </div>
        <div className="page-sub">
          {"// "}
          {terminal} · {prodLabel.toUpperCase()}
        </div>
      </div>

      {alertes.map((a) => (
        <div key={a.stationId} className="alert alert-red">
          🔴 <strong>{a.label}</strong> —{" "}
          {a.vide ? "Stock vide" : `Niveau critique (${a.stock} m³)`}. Seuil:{" "}
          {a.seuil} m³.
        </div>
      ))}

      <div className="card" style={{ marginBottom: 14 }}>
        <div className="card-header">
          <span className="card-title">⟶ Flux de circulation</span>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            overflowX: "auto",
            padding: 14,
            gap: 0,
            scrollbarWidth: "none",
          }}
        >
          {[
            {
              icon: "🔒",
              label: "Sous douane",
              val: loading ? "…" : fmt(stockProduit.sd),
              unit: "m³",
              clickable: true,
              page: "sous-douane",
            },
            { arrow: true },
            {
              icon: "✅",
              label: "Libre pratique",
              val: loading ? "…" : fmt(stockProduit.lp),
              unit: "m³",
              clickable: true,
              page: "libre-pratique",
            },
            { arrow: true },
            {
              icon: "📋",
              label: "Commande en cours",
              val: loading ? "…" : fmt(totalBLRestant),
              unit: "m³ restants",
            },
            { arrow: true },
            {
              icon: "⛽",
              label: "Stations",
              val: loading ? "…" : fmt(totalStations),
              unit: "m³",
            },
          ].map((item, i) =>
            item.arrow ? (
              <div
                key={i}
                style={{
                  padding: "0 6px",
                  color: "var(--muted)",
                  fontSize: 18,
                  flexShrink: 0,
                }}
              >
                →
              </div>
            ) : (
              <FlowBox
                key={i}
                {...item}
                onClick={() => item.clickable && setActivePage(item.page)}
              />
            ),
          )}
        </div>
      </div>

      <div className="kpi-grid">
        <KpiCard
          label="🔒 Sous douane"
          value={loading ? "…" : fmt(stockProduit.sd)}
          unit="m³ bloqués"
          color="var(--gold)"
          onClick={() => setActivePage("sous-douane")}
        />
        <KpiCard
          label="✅ Libre pratique"
          value={loading ? "…" : fmt(stockProduit.lp)}
          unit="m³ disponibles"
          color={accentColor}
          onClick={() => setActivePage("libre-pratique")}
        />
        <KpiCard
          label="📋 Commande en cours"
          value={loading ? "…" : fmt(totalBLRestant)}
          unit="m³ à livrer"
          color="var(--green)"
        />
        <KpiCard
          label="⛽ Total stations"
          value={loading ? "…" : fmt(totalStations)}
          unit="m³ en station"
          color="var(--red)"
        />
      </div>
    </div>
  );
}

function FlowBox({ icon, label, val, unit, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        flexShrink: 0,
        minWidth: 90,
        textAlign: "center",
        background: "var(--bg)",
        border: "1px solid var(--border)",
        borderRadius: 8,
        padding: "10px 8px",
        cursor: onClick ? "pointer" : "default",
        transition: "all 0.2s",
      }}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.background = "var(--border)";
          e.currentTarget.style.transform = "translateY(-2px)";
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.background = "var(--bg)";
          e.currentTarget.style.transform = "translateY(0)";
        }
      }}
    >
      <div style={{ fontSize: 18, marginBottom: 4 }}>{icon}</div>
      <div
        style={{
          fontFamily: "var(--font-mono)",
          fontSize: 7,
          color: "var(--muted)",
          textTransform: "uppercase",
          letterSpacing: 1,
          marginBottom: 3,
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontFamily: "var(--font-head)",
          fontSize: 16,
          fontWeight: 800,
          color: "var(--white)",
        }}
      >
        {val}
      </div>
      <div
        style={{
          fontFamily: "var(--font-mono)",
          fontSize: 7,
          color: "var(--muted)",
        }}
      >
        {unit}
      </div>
    </div>
  );
}

function KpiCard({ label, value, unit, color, onClick }) {
  return (
    <div
      className="kpi-card"
      style={{ "--kpi-color": color }}
      onClick={onClick}
    >
      <div className="kpi-label">{label}</div>
      <div className="kpi-value">{value ?? "—"}</div>
      <div className="kpi-unit">{unit}</div>
    </div>
  );
}
